<template>
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
  >
    <path d="M0.397052 0.553789L0.46967 0.46967C0.735936 0.203403 1.1526 0.179197 1.44621 0.397052L1.53033 0.46967L6 4.939L10.4697 0.46967C10.7626 0.176777 11.2374 0.176777 11.5303 0.46967C11.8232 0.762563 11.8232 1.23744 11.5303 1.53033L7.061 6L11.5303 10.4697C11.7966 10.7359 11.8208 11.1526 11.6029 11.4462L11.5303 11.5303C11.2641 11.7966 10.8474 11.8208 10.5538 11.6029L10.4697 11.5303L6 7.061L1.53033 11.5303C1.23744 11.8232 0.762563 11.8232 0.46967 11.5303C0.176777 11.2374 0.176777 10.7626 0.46967 10.4697L4.939 6L0.46967 1.53033C0.203403 1.26406 0.179197 0.8474 0.397052 0.553789L0.46967 0.46967L0.397052 0.553789Z" />
  </svg>
</template>
